
    export const BoxLabelVAStyles = {
        position: "relative",
        marginRight: "auto",
        backgroundColor: (theme) =>
            theme.palette.mode === "dark"
                ? "rgb(48, 48, 48)"
                : "rgb(250, 250, 250)",
        fontWeight: "1000",
        fontStyle: "italic",
        fontSize: "16px",
        fontFamily: ["Century !important"].join(",")
    }
    export const BoxVAStyles = {
        padding: "10px",
        margin: "25px",
        border: "1px solid"
    }
    export const FunctionButtonStyles = {
        display: "block",
        width: "140px",
        height: "60px",
        marginTop: "10px",
        marginBottom: "10px"
    }
    export const SelectTextStyles = {
        padding: "10px"
    }
    export const rootStyles = (theme) => ({
        [theme.breakpoints.between("sm", 1000)]: {
            paddingLeft: "5%",
            paddingRight: "5%"
        },
        [theme.breakpoints.between(1000, 1400)]: {
            paddingLeft: "8%",
            paddingRight: "8%"
        },
        [theme.breakpoints.between(1400, 1800)]: {
            paddingLeft: "12%",
            paddingRight: "12%"
        },
        [theme.breakpoints.between(1800, 2000)]: {
            paddingLeft: "15%",
            paddingRight: "15%"
        },
        [theme.breakpoints.up(2000)]: {
            paddingLeft: "20%",
            paddingRight: "20%"
        }
    })
    export const RecipientBoxStyles = {
        marginTop: "20px",
        marginBottom: "20px"
    }
    export const EmailValStyles = {
        paddingTop: "7px",
        fontSize: "15px",
        overflow: "hidden"
    }
    export const RecipientLabelStyles = {
        paddingTop: "7px",
        fontSize: "15px",
        fontWeight: "600"
    }
    export const NoneEmailsStyles = {
        paddingTop: "7px",
        fontSize: "15px",
        fontStyle: "italic"
    }
    export const AddEmailStyles = {
        paddingTop: "35px"
    }
    export const EmailTextFieldStyles = {
        width: "80%"
    }
    export const DeleteButtonStyles = {
        paddingLeft: "5px"
    }
    export const notchedOutlineStyles = {
        borderWidth: "1px",
        borderColor: "grey !important"
    }
    export const floatingLabelFocusStyleStyles = {
        color: "grey !important"
    }